import { NdaStatus } from 'models/Nda';
import { User } from 'models/User';
import { ObjectValues } from 'types';

export const BOSS_MODE_TRACK_EVENTS = {
  DRAFT_LISTING: 'draft_listing',
  EDIT_LISTING: 'edit_listing',
  SEND_MESSAGE: 'send_message',
  CHANGE_NDA_STATUS: 'change_nda_status',
  LEAD_NOTE: 'lead_note',
  DEAL_NOTE: 'deal_note',
  ADD_LEAD: 'add_lead',
} as const;

type BossModeTrackEvents = ObjectValues<typeof BOSS_MODE_TRACK_EVENTS>;

export const BOSS_MODE_TRACK_EVENTS_LABEL: Record<BossModeTrackEvents, string> =
  {
    [BOSS_MODE_TRACK_EVENTS.DRAFT_LISTING]: 'listingDrafted',
    [BOSS_MODE_TRACK_EVENTS.EDIT_LISTING]: 'listingEdited',
    [BOSS_MODE_TRACK_EVENTS.SEND_MESSAGE]: 'messageSent',
    [BOSS_MODE_TRACK_EVENTS.CHANGE_NDA_STATUS]: 'ndaStatusChanged',
    [BOSS_MODE_TRACK_EVENTS.LEAD_NOTE]: 'leadNoteAdded',
    [BOSS_MODE_TRACK_EVENTS.DEAL_NOTE]: 'dealNoteAdded',
    [BOSS_MODE_TRACK_EVENTS.ADD_LEAD]: 'leadAdded',
  };

export const BOSS_MODE_TRACK_EVENTS_COLOR: Record<BossModeTrackEvents, string> =
  {
    [BOSS_MODE_TRACK_EVENTS.DRAFT_LISTING]: 'blue',
    [BOSS_MODE_TRACK_EVENTS.EDIT_LISTING]: 'blue',
    [BOSS_MODE_TRACK_EVENTS.SEND_MESSAGE]: 'light-green',
    [BOSS_MODE_TRACK_EVENTS.CHANGE_NDA_STATUS]: 'orange',
    [BOSS_MODE_TRACK_EVENTS.LEAD_NOTE]: 'green',
    [BOSS_MODE_TRACK_EVENTS.DEAL_NOTE]: 'green',
    [BOSS_MODE_TRACK_EVENTS.ADD_LEAD]: 'dark-green-full',
  };

export type BossModeTrack = {
  _id: string;

  eventType: BossModeTrackEvents;

  //user who trigerrs event
  userId: string;
  user: Partial<User> | null;

  count: number;
  dealRoomIds: string[];
  leadIds: string[];

  // populated in getBossModeTracks
  dealRoomNames?: string[];
  leadNames?: string[];

  //for send_message event
  receiverUserId: string;
  receiver: Partial<User> | null;

  //for change_nda_status event
  previousNdaStatus: NdaStatus;
  newNdaStatus: NdaStatus;

  envelopeTemplateName?: string;

  lastEventAt?: Date;
  createdAt: Date;
};

export type TableHeaderKey = keyof BossModeTrack;

export type BossModeStatsFilters = {
  page?: string;
  eventType?: string;
  userId?: string;
  buyerIds?: string;
  dealRoomIds?: string;
  previousNdaStatus?: string;
  newNdaStatus?: string;
  timeframe?: string;
};

export const EVENT_FILTER_KEY = 'eventType';

export const USER_ID_FILTER_KEY = 'userId';
export const USER_NAME_FILTER_KEY = 'userName';

export const LEAD_ID_FILTER_KEY = 'buyerIds';
export const LEAD_NAME_FILTER_KEY = 'buyerNames';

export const DEAL_FILTER_KEY = 'dealRoomIds';
export const DEAL_TITLE_FILTER_KEY = 'dealRoomNames';

export const PREVIOUS_NDA_STATUS_FILTER_KEY = 'previousNdaStatus';
export const NEW_NDA_STATUS_FILTER_KEY = 'newNdaStatus';

export const TIMEFRAME_FILTER = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_3_MONTHS: 'last_3_months',
  LAST_6_MONTHS: 'last_6_months',
  LAST_12_MONTHS: 'last_12_months',
} as const;

export type TimeframeFilter = ObjectValues<typeof TIMEFRAME_FILTER>;
